exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table td a i[data-v-0645fadc] {\n  font-size: 15px;\n}", ""]);

// exports
